import { useState } from "react";

interface TopHeaderProps {
  title: string;
  subtitle?: string;
  onMenuClick: () => void;
}

export default function TopHeader({ title, subtitle, onMenuClick }: TopHeaderProps) {
  const [showNotif, setShowNotif] = useState(false);

  const notifications = [
    { icon: "ri-money-cny-circle-line", text: "18 veliye ödeme hatırlatması gönderilecek", time: "Bugün 09:00", color: "amber" },
    { icon: "ri-user-add-line", text: "Referans kampanyası %42 tamamlandı", time: "Devam ediyor", color: "emerald" },
    { icon: "ri-file-list-3-line", text: "11 öğrencinin taahhüdü 30 gün içinde bitiyor", time: "Acil", color: "orange" },
  ];

  return (
    <header className="sticky top-0 z-30 bg-white border-b border-gray-100 h-16 flex items-center px-4 md:px-6 gap-4">
      {/* Hamburger */}
      <button
        onClick={onMenuClick}
        className="lg:hidden w-9 h-9 flex items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100 cursor-pointer transition-colors"
      >
        <i className="ri-menu-line text-xl"></i>
      </button>

      {/* Title */}
      <div className="flex-1 min-w-0">
        <h1 className="text-base md:text-lg font-bold text-gray-900 leading-tight truncate">{title}</h1>
        {subtitle && <p className="text-xs text-gray-400 leading-tight hidden sm:block">{subtitle}</p>}
      </div>

      {/* System status */}
      <div className="hidden md:flex items-center gap-2 px-3 py-1.5 bg-emerald-50 rounded-full">
        <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
        <span className="text-xs text-emerald-700 font-medium whitespace-nowrap">Sistem Aktif</span>
      </div>

      {/* Notification */}
      <div className="relative">
        <button
          onClick={() => setShowNotif(!showNotif)}
          className="w-9 h-9 flex items-center justify-center rounded-xl bg-gray-50 hover:bg-gray-100 text-gray-500 cursor-pointer transition-colors relative"
        >
          <i className="ri-notification-3-line text-lg"></i>
          <span className="absolute top-1 right-1 w-4 h-4 bg-red-500 rounded-full text-white text-[9px] font-bold flex items-center justify-center">3</span>
        </button>

        {showNotif && (
          <div className="absolute right-0 top-12 w-80 bg-white rounded-2xl shadow-xl border border-gray-100 py-2 z-50">
            <div className="px-4 py-2 border-b border-gray-100">
              <p className="text-sm font-semibold text-gray-800">Bildirimler</p>
            </div>
            {notifications.map((n, i) => (
              <div key={i} className="px-4 py-3 hover:bg-gray-50 cursor-pointer transition-colors">
                <div className="flex gap-3">
                  <div className={`w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0
                    ${n.color === "amber" ? "bg-amber-100 text-amber-600" : ""}
                    ${n.color === "emerald" ? "bg-emerald-100 text-emerald-600" : ""}
                    ${n.color === "orange" ? "bg-orange-100 text-orange-600" : ""}
                  `}>
                    <i className={`${n.icon} text-sm`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-xs text-gray-700 leading-snug">{n.text}</p>
                    <p className="text-[10px] text-gray-400 mt-0.5">{n.time}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Profile */}
      <div className="flex items-center gap-2 cursor-pointer group">
        <div className="w-9 h-9 rounded-full bg-[#0B1120] flex items-center justify-center">
          <span className="text-white text-xs font-bold">EK</span>
        </div>
        <div className="hidden sm:block">
          <p className="text-xs font-semibold text-gray-800 leading-tight">Eğitim Danışmanı</p>
          <p className="text-[10px] text-gray-400 leading-tight">GoStudent</p>
        </div>
      </div>
    </header>
  );
}